import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities';

type Props = {
  displayName: string;
  fullName: string;
  query: string;
};

const NameAndSignatureQuery = ({ displayName, fullName, query }: Props) => {
  const parser = TextEntities.createTextMatchingParser(query);

  let fullNameComponent;
  if (query !== '' && fullName && parser(fullName).length > parser(displayName).length) {
    fullNameComponent = (
      <TextWithEntities text={`(${fullName})`} entities={parser(`(${fullName})`)} />
    );
  } else {
    fullName = '';
  }

  const displayNameComponent = (
    <TextWithEntities text={displayName} entities={parser(displayName)} />
  );

  return (
    <div>
      {displayNameComponent} {fullNameComponent}
    </div>
  );
};

export default NameAndSignatureQuery;
